import Vue from "vue";
import Router from "vue-router";
import SharePage from "../components/sharePage.vue";
import JumpPage from "../components/jumpPage.vue";
import linkManage from "@/components/linkManage.vue";
import GatePage from "@/components/gatePage.vue";
import UpdatePwd from "@/components/updatePwd.vue";

//Vue中使用router插件
Vue.use(Router);

//路由配置，配置路由路径与组件的对应关系
const routes = [
  {
    path: "/wxwork/SharePage/:pathMatch(.*)*",
    component: SharePage,
  },
  {
    path: "/linkManage",
    component: linkManage,
    meta: { needPassword: true }
  },
  {
    path: "/x9k2p-gate-7m4q",
    component: GatePage,
  },
  {
    path: "/x9g2px-updatePwd-7m6q",
    component: UpdatePwd,
  },
  {
    path: "/*",
    component: JumpPage,
  },
];

//新建路由实例
const router = new Router({
  routes,
  mode: "history",
});

//导出路由实例，在main.js中导入使用
export default router;
